<div id="page-container">
  <div id="central-container" class="flex-col content-between align-items-center">
    <div id="header" class="flex-col content-center light-blue text-center align-items-center">
      <img src="assets/shield-icon.svg" id="logo">
      <h1 class="bold title-text">DEMANDE DE RENVOI DU LIEN D'INVITATION</h1>
      <p class="sub-title-text text-lg">
        <span class="bold">Vous n’avez pas reçu ou avez perdu votre lien d’invitation ?</span>
        Saisissez votre adresse email ci-dessous et
        cliquez sur <span class="bold">« Recevoir mon invitation »</span> pour le recevoir à nouveau.
      </p>
    </div>
    <div id="form-holder" class="flex-col align-items-center content-center">
      <div class="input-wrapper">
        <input type="text" class="input-text" placeholder="Adresse e-mail" (input)="onUserInput($event)">
        <img src="assets/success-icon.svg" class="email-valid-logo" width="14px" *ngIf="mailInput.length !== 0 && validEmail">
        <img src="assets/failure-icon.svg" class="email-valid-logo" width="14px" *ngIf="mailInput.length !== 0 && !validEmail">
      </div>
      <p class="text-sm dark-blue input-description" *ngIf="mailInput.length === 0">
        <span class="exclamation white">!</span>Adresse e-mail obligatoire
      </p>
      <p class="text-sm red input-description" *ngIf="mailInput.length !== 0 && !validEmail">
        Format d'adresse e-mail invalide
      </p>
      <p class="text-sm green input-description" *ngIf="mailInput.length !== 0 && validEmail">
        Format d'adresse e-mail valide
      </p>
      <button [ngClass]="validEmail && !loading ? 'action-button' : 'action-button-disabled'"
        (click)="validEmail && !loading && login()">
        <span *ngIf="!loading">Recevoir mon invitation</span>
        <span *ngIf="loading" class="spinner"></span>
      </button>
    </div>
    <div id="description" class="text-center mt-30">
      <p class="light-blue bold no-margin">C'EST SIMPLE, RAPIDE ET SÉCURISÉ</p>
      <p class="dark-blue no-margin">Cette démarche est réalisée selon des protocoles de sécurité établis, assurant une
        expérience à la fois rapide,
        fiable et maîtrisée.</p>
    </div>
    <div id="footer" class="flex-col content-center align-items-center text-center">
      <img [ngClass]="isMobile ? 'v8te-logo v8te-logo-mobile' : 'v8te-logo'" src="assets/v8te.png" alt="v8te-loge"
        style="height: 128px;">
      <p class="no-margin dark-blue">Contactez notre support : <a href="mailto:support_client@v8te.com"
          class="email-link">support_client&#64;v8te.com</a></p>
      <p class="dark-blue">Ce site est protégé par les Conditions générales et la Politique de
        confidentialité de v8te.</p>
    </div>
    <app-recover-popup class="popup-recover" *ngIf="displayRecoveryPopup" (closePopup)="displayRecoveryPopup = false"
      [recoverSucceeded]="requestResult" [email]="mailInput">

    </app-recover-popup>
  </div>
</div>